import React from "react";
import { Helmet } from "react-helmet";

const ConversionAdsHelmet = ({ title }) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="title" content="客製化軟體開發 | 匯融科技" />
            <meta name="keywords" content="程式接案,專案外包,軟體外包,客製化軟體開發" />
            <meta name="description" content="提供程式軟體開發人力需求 解決客戶在資訊系統開發與維護不同階段的人力資源需求，匯融擁有超過 15 年 委外軟體開發、教育訓練、資訊系統整合、委外、開發、維護等資訊服務經驗，客戶遍及製造業、電子業、科技業、一般公司，及政府部門等產業，能提供企業專業技術人才，強化核心競爭力！" />
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11265085089"></script>
            <script>
                {`
                                window.dataLayer = window.dataLayer || [];
                                function gtag() {
                                    dataLayer.push(arguments)
                                }
                                gtag('js', new Date());
                                gtag('config', 'AW-11265085089');
                `}
            </script>
            <script>
                {
                    `
                    gtag('event', 'conversion', {'send_to': 'AW-11265085089/IgpQCJGs-eUYEKGdzvsp'});
                    `
                }
            </script>
        </Helmet>
    );
}

export default ConversionAdsHelmet;